import type { DeviceInfo } from "../utils/device/types";

export interface SessionRequest {
  unique_id: string;
  mac_address: string;
  os: string;
  os_version: string;
  app_version: string;
  country: string;
  is_emulator: boolean;
  is_pin_set: boolean;
  is_tablet: boolean;
  is_root: boolean;
  device_brand: string;
  device_build_number: string;
  device_carrier: string;
  device_id: string;
  device_locale: string;
  device_name: string;
}

export const mapDeviceInfoToSessionRequest = (deviceInfo: DeviceInfo): SessionRequest => {
  return {
    unique_id: deviceInfo.unique_id,
    mac_address: deviceInfo.mac_address,
    os: deviceInfo.os,
    os_version: deviceInfo.os_version,
    app_version: deviceInfo.app_version,
    country: deviceInfo.country,
    is_emulator: deviceInfo.is_emulator,
    is_pin_set: deviceInfo.is_pin_set,
    is_tablet: deviceInfo.is_tablet,
    is_root: false,
    device_brand: deviceInfo.device_brand,
    device_build_number: deviceInfo.device_build_number,
    device_carrier: deviceInfo.device_carrier,
    device_id: deviceInfo.device_id,
    device_locale: deviceInfo.device_locale,
    device_name: deviceInfo.device_name,
  };
};
